'use strict';

export default angular
  .module('maestro.filters.formatPhoneNumber', [])

  .filter('formatPhoneNumber', function($filter, utils) {
    let $t = $filter('translate');
    return (value, type) => {
      if (!value) {
        return $t('users.list.noPhone');
      }
      return utils.formatPhoneNumber(value, type, angular.isUndefined(type) || type ===  0);
    };
  })

  .name;
